import { useEffect, useRef, useState } from "react";
import "../App.css";
import { toast } from "react-toastify";
import { AddCircleOutlineRounded } from "@mui/icons-material";
import "./Section.css";
import addImageIcon from "../assets/icons/add-image.png";
import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import EducationsDataTable from "../components/data-tables/EducationsDataTable";
import SelectCategory from "../components/select-category/SelectCategory";
import { API } from "../assets/staticData";
import SelectLang from "../components/select-lang/SelectLang";
import AddCat from "../components/add-cat/AddCat";
import ClearCacheButton from "../components/ClearCacheButton/ClearCacheButton";
import { CACHE_KEY } from "../constant/cache-key";

let userToken = localStorage.getItem("userToken");

const headers = {
  Authorization: `Bearer ${userToken}`,
};

export default function Videos({ user }) {
  const [error, setError] = useState(null);
  const [platforms, setPlatforms] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [cat, setCat] = useState("");
  const [refreshCats, setRefreshCats] = useState(false);
  const [lang, setLang] = useState("");
  const [keywords, setKeywords] = useState([]);
  const [image, setImage] = useState(null);
  const [userInfo, setuserInfo] = useState();
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const formData = new FormData();
  const hiddenFileInput = useRef();
  const [meta, setMeta] = useState({
    pagination: {
      page: 0,
      pageSize: 0,
      pageCount: 0,
      total: 0
    }
  })
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState({
    title: "",
    link: "",
  });

  async function getData(page = 0) {
    try {
      setLoading(true)
      const res = await fetch(`${API}/videos?populate=*&sort=createdAt:desc&pagination[pageSize]=10&pagination[page]=${page}`, {
        headers,
        method: "GET",
      })

      const respone = await res.json()
      setPlatforms(respone.data);
      setMeta(respone.meta)

      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  useEffect(() => {
    getData();
  }, [refresh]);

  useEffect(() => {
    async function getData() {
      fetch(`${API}/users/me?populate=*`, {
        headers,
        method: "GET",
      }).then(async (res) => {
        const respone = await res.json();
        setuserInfo(respone);
      });
    }

    async function getUsers() {
      fetch(`${API}/users`, {
        headers,
        method: "GET",
      }).then(async (res) => {
        const response = await res.json();
        setUsers(response);
      });
    }

    getData();
    getUsers();
  }, []);

  if (error) {
    // Print errors if any
    return <div>An error occured: {error.message}</div>;
  }

  const handleInputChange = (field, value) => {
    setData({
      ...data,
      [field]: value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setImage(file);
    }
  };

  const uploadItem = () => {
    if (
      data.title !== "" &&
      data.link !== "" &&
      image !== null &&
      image !== "" &&
      cat !== "" &&
      lang !== ""
    ) {
      formData.append(
        "data",
        JSON.stringify({
          ...data,
          category_relation: cat.id,
          category: cat?.attributes?.category,
          lang: lang,
          users_permissions_user: selectedUser || userInfo.id,
          public: true,
        })
      );
      formData.append("files.image", image, image.name);
      fetch(`${API}/videos`, {
        headers,
        method: "POST",
        body: formData,
      })
        .then(() => {
          setData({
            title: "",
            link: "",
          });
          setImage(null);
          setCat("");
          setSelectedUser("")
          setLang("");
          setOpenAdd(false);
          setRefresh(!refresh);
          toast("The Platform was successfully added", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        })
        .catch((error) => setError(error));
    } else {
      toast("Please fill the required fields", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "error",
      });
    }
  };

  const onFetchVideos = async ({ page, pageSize }) => {
    await getData(page + 1)
  }

  return (
    <div className="App">

      <Box mt={2}>
        <ClearCacheButton
          keys={[
            CACHE_KEY.videos
          ]} />
      </Box>

      <div>
        <h3 style={{ textAlign: "start", marginBottom: 10 }}>Video Content Settings</h3>

        {user.perms[19].add && (
          <div
            className="addC"
            style={{ minHeight: openAdd ? 500 : 50, padding: openAdd ? 20 : 0 }}>
            {openAdd && (
              <div
                className="addContent"
                style={{
                  marginTop: 10,
                  marginBottom: 20,
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  alignItems: "center",
                }}>
                <div style={{ width: "100%", display: "flex" }}>
                  <div
                    style={{
                      width: "50%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 10,
                    }}>
                    <TextField
                      label="Title"
                      sx={{ width: "90%" }}
                      value={data.title}
                      onChange={(e) => handleInputChange("title", e.target.value)}
                    />
                    <TextField
                      label="YouTube Link"
                      sx={{ width: "90%" }}
                      value={data.link}
                      onChange={(e) => handleInputChange("link", e.target.value)}
                    />
                    <SelectLang lang={lang} setLang={setLang} />

                    {(userInfo?.id === 40 || userInfo?.id === 36) && (
                      <FormControl sx={{ width: "90%" }}>
                        <InputLabel id="author-select-label">Select Author</InputLabel>
                        <Select
                          labelId="author-select-label"
                          id="author-select"
                          value={selectedUser}
                          label="Select Author"
                          onChange={(e) => {
                            setSelectedUser(e.target.value);
                          }}>
                          {users.map((user) => (
                            <MenuItem key={user.id} value={user.id}>
                              {user.username}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </div>
                  <div
                    style={{
                      width: "50%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 10,
                    }}>
                    <div
                      style={{
                        border: "dashed",
                        borderWidth: 1,
                        borderColor: "grey",
                        height: 135,
                        marginTop: 1,
                        width: "90%",
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                        justifyContent: "center",
                        borderRadius: 5,
                        cursor: "pointer",
                      }}
                      onClick={() => hiddenFileInput.current.click()}>
                      {image ? (
                        <img
                          src={URL.createObjectURL(image)}
                          style={{
                            width: 55,
                            aspectRatio: 1,
                            borderRadius: 55,
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <img src={addImageIcon} style={{ width: 55 }} />
                      )}
                      <p style={{ color: "#888", fontSize: 13 }}>Click here to add an image</p>
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={handleImageChange}
                        ref={hiddenFileInput}
                        style={{ display: "none" }}
                      />
                    </div>

                    <SelectCategory cat={cat} setCat={setCat} refreshCats={refreshCats} />
                    <AddCat refreshCats={refreshCats} setRefreshCats={setRefreshCats} />
                  </div>
                </div>
              </div>
            )}
            <div
              className="addBTN"
              onClick={() => (openAdd ? uploadItem() : setOpenAdd(true))}
              style={{ width: openAdd ? "50%" : "100%" }}>
              {openAdd ? "Submit" : " Add a new Video"}
              <AddCircleOutlineRounded style={{ marginLeft: 7 }} />
            </div>

            {openAdd && (
              <div
                onClick={() => {
                  setOpenAdd(false);
                  setImage(null);
                  setKeywords([]);
                  setCat("");
                  setLang("");
                  setData({
                    title: "",
                    subTitle: "",
                    content: "",
                    summary: "",
                    authorOpinion: "",
                  });
                }}
                className="cancelBTN">
                Cancel
              </div>
            )}
          </div>
        )}

        <EducationsDataTable
          data={platforms}
          meta={meta}
          endpoint={"videos"}
          user={user}
          permNumber={19}
          refresh={refresh}
          setRefresh={setRefresh}
          onChangeQuery={onFetchVideos}
          loading={loading}
        />
      </div>
    </div>
  );
}
